import styles from './RedemptionAmountMessage.module.scss';
import React from 'react';
export const RedemptionAmountMessage: React.FC = () => {
  return (
    <aside className={styles['redemption-message']}>
      Important Note: Because you entered the redemption amount as a percentage
      or number of shares, an estimated calculation is shown here. Annual
      Percentage elections will display the full annual distribution. Exact
      values will be calculated at the time the trade is placed.
    </aside>
  );
};
